import React, { useCallback } from 'react';
import range from 'lodash/range';
import PlaceholderBlock from '../../../PlaceholderBlock';
import TitlePlaceholder from '../TitlePlaceholder';
import Grid from '../../../Grid/MeasuredGrid';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import s from './LoaderBlock.scss';

interface Props {
  index?: number;
}

const items = range(0, 9);

const LoaderBlock: React.FC<Props> = ({ index }) => {
  const renderItem = useCallback(({ height, width, index: itemIndex, style }) => {
    return (
      <div key={itemIndex} style={style}>
        <PlaceholderBlock width={width} height={height} />
      </div>
    );
  }, []);

  return (
    <div className={s['root']}>
      <div className={s['block-header']}>
        <TitlePlaceholder splitIndex={index} />
      </div>
      <Grid
        lazyloadFromContext
        enableScrollOptim={false}
        containerWidth={308}
        defaultSize={{
          desktop: { width: 308, height: 308 },
          mobile: { width: 308, height: 308 },
        }}
        cookieType={MeasuredCookieType.DEVIATION_SIDEBAR}
        maxRows={3}
        breakpoints={[
          {
            maxWidth: 308,
            elementsPerRow: 3,
            elementAspectRatio: 1,
          },
        ]}
        spacing={16}
        elementCount={items.length}
        renderElement={renderItem}
      />
    </div>
  );
};
LoaderBlock.displayName = 'LoaderBlock';

export default LoaderBlock;
